import get from 'lodash/get';
import { SET_SCREEN_VIEWPORT, SET_LIST_RELATION, IS_INTERNET_CONNECTED } from '../actions/meta';
import { getScreenViewport } from '../../utils';
import HELPER from './helper';

const initialState = {
  userAgent: HELPER.getBrowser(window.navigator.userAgent),
  os: HELPER.getOperatingSystem(window),
  platform: HELPER.getDeviceType(),
  screenViewport: getScreenViewport(),
  listRelation: {},
  onLine: navigator.onLine,
};

const getRelation = (question) => {
  const pId = get(question, 'properties.parent_list_id', '');
  const qId = question.question_id.split('_$ureify_')[1];
  return {
    [qId]: pId,
  };
};

function updateListRelation(listRelation, payload) {
  const { question, activeSubsectionId } = payload;
  if (listRelation[activeSubsectionId]) {
    return {
      ...listRelation,
      [activeSubsectionId]: {
        ...listRelation[activeSubsectionId],
        ...getRelation(question),
      },
    };
  }
  return {
    ...listRelation,
    [activeSubsectionId]: getRelation(question),
  };
}

function meta(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_SCREEN_VIEWPORT:
      return {
        ...state,
        screenViewport: payload,
      };
    case SET_LIST_RELATION:
      return {
        ...state,
        listRelation: updateListRelation(state.listRelation, action.payload),
      };
    case IS_INTERNET_CONNECTED:
      return {
        ...state,
        onLine: payload,
      };
    default:
      return state;
  }
}

export default meta;
